import * as Yup from 'yup';
import { EDOZVOLA_WEB_ID_REGEX, messages } from 'app/config/constants';
import { APPLICANT_PARTY_TYPE_ENUM, SUBJECT_TYPE_ENUM } from 'app/shared/enumeration/enums';
import { defaultAddressValidation } from 'app/shared/address-input/model/address.schema';

export const caseApplicantValidationSchema = Yup.object({
  partyType: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  subjectType: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  person: Yup.object()
    .nullable()
    .notRequired()
    .when(['subjectType'], (subjectType, schema) => {
      if (subjectType && subjectType[0] && subjectType[0][0] && subjectType[0][0].id === SUBJECT_TYPE_ENUM.FIZICKA_OSOBA) {
        return Yup.object({
          oib: Yup.string()
            .required(messages.MANDATORY_FIELD)
            .matches(/^\d+$/, messages.ONLY_DIGITS)
            .min(11, messages.OIB_MIN_MAX_LENGTH)
            .max(11, messages.OIB_MIN_MAX_LENGTH),
          firstName: Yup.string().required(messages.MANDATORY_FIELD),
          lastName: Yup.string().required(messages.MANDATORY_FIELD),
        });
      } else if (subjectType && subjectType[0] && subjectType[0][0] && subjectType[0][0].id === SUBJECT_TYPE_ENUM.PRAVNA_OSOBA) {
        return Yup.object({
          oib: Yup.string().notRequired(),
          firstName: Yup.string().notRequired(),
          lastName: Yup.string().notRequired(),
        }).notRequired();
      }
    }),
  legalEntity: Yup.object().when('subjectType', (subjectType, schema) => {
    if (subjectType && subjectType[0] && subjectType[0][0] && subjectType[0][0].id === SUBJECT_TYPE_ENUM.PRAVNA_OSOBA) {
      return Yup.object({
        oib: Yup.string()
          .required(messages.MANDATORY_FIELD)
          .matches(/^\d+$/, messages.ONLY_DIGITS)
          .min(11, messages.OIB_MIN_MAX_LENGTH)
          .max(11, messages.OIB_MIN_MAX_LENGTH),
        mb: Yup.string().notRequired(),
        companyName: Yup.string().required(messages.MANDATORY_FIELD),
      });
    } else if (subjectType && subjectType[0] && subjectType[0][0] && subjectType[0][0].id === SUBJECT_TYPE_ENUM.FIZICKA_OSOBA) {
      return Yup.object({
        oib: Yup.string().notRequired(),
        companyName: Yup.string().notRequired(),
      }).notRequired();
    } else if (
      subjectType &&
      subjectType[0] &&
      subjectType[0][0] &&
      (subjectType[0][0].id === SUBJECT_TYPE_ENUM.OBRT ||
        subjectType[0][0].id === SUBJECT_TYPE_ENUM.SLOBODNA_DJELATNOST ||
        subjectType[0][0].id === SUBJECT_TYPE_ENUM.OPG)
    ) {
      return Yup.object({
        oib: Yup.string().notRequired(),
        mb: Yup.string()
          .required(messages.MANDATORY_FIELD)
          .matches(/^\d+$/, messages.ONLY_DIGITS)
          .max(11, messages.MB_MAX_LENGTH),
        companyName: Yup.string().required(messages.MANDATORY_FIELD),
      }).notRequired();
    }
  }),
  applicantAddress: defaultAddressValidation,
  email: Yup.string().email('Neispravan format').notRequired(),
  applicants: Yup.object().when('partyType', (partyType, schema) => {
    if (partyType && partyType[0] && partyType[0][0] && partyType[0][0].id === APPLICANT_PARTY_TYPE_ENUM.OPUNOMOCENIK_PODNOSITELJA) {
      return Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD);
    }
    return Yup.array().notRequired();
  }),
  procurationType: Yup.object().when('partyType', (partyType, schema) => {
    if (partyType && partyType[0] && partyType[0][0] && partyType[0][0].id === APPLICANT_PARTY_TYPE_ENUM.OPUNOMOCENIK_PODNOSITELJA) {
      return Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD);
    }
    return Yup.array().notRequired();
  }),
});

export const caseApplicantCaseUuidToCopyFromSchema = Yup.object({
  caseUuidToCopyFrom: Yup.string().matches(EDOZVOLA_WEB_ID_REGEX, 'Unesena šifra predmeta je neispravna!'),
});

export const applicantsNumberSchema = Yup.object({
  applicantsNumber: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
});

export const caseApplicantWithNonMandatoryOibValidationSchema = Yup.object({
  partyType: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  subjectType: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  oibFetched: Yup.boolean().notRequired(),
  person: Yup.object()
    .nullable()
    .notRequired()
    .when(['subjectType', 'oibFetched'], (keys, schema) => {
      if (keys && keys[0] && keys[0][0] && keys[0][0].id === SUBJECT_TYPE_ENUM.FIZICKA_OSOBA) {
        return Yup.object({
          oib: keys[1]
            ? Yup.string().required(messages.MANDATORY_FIELD).matches(/^\d+$/, messages.ONLY_DIGITS).length(11, messages.OIB_MIN_MAX_LENGTH)
            : Yup.string().notRequired(),
          firstName: Yup.string().required(messages.MANDATORY_FIELD),
          lastName: Yup.string().required(messages.MANDATORY_FIELD),
        }).nullable();
      } else if (keys && keys[0] && keys[0][0] && keys[0][0]?.id === SUBJECT_TYPE_ENUM.PRAVNA_OSOBA) {
        return Yup.object({
          oib: Yup.string().notRequired(),
          firstName: Yup.string().notRequired(),
          lastName: Yup.string().notRequired(),
        })
          .nullable()
          .notRequired();
      }
      return schema;
    }),

  legalEntity: Yup.object().when(['subjectType', 'oibFetched'], keys => {
    if (keys && keys[0] && keys[0][0] && keys[0][0]?.id === SUBJECT_TYPE_ENUM.PRAVNA_OSOBA) {
      return Yup.object({
        oib: keys[1]
          ? Yup.string().required(messages.MANDATORY_FIELD).matches(/^\d+$/, messages.ONLY_DIGITS).length(11, messages.OIB_MIN_MAX_LENGTH)
          : Yup.string().notRequired(),
        companyName: Yup.string().required(messages.MANDATORY_FIELD),
      });
    } else if (keys && keys[0] && keys[0][0] && keys[0][0]?.id === SUBJECT_TYPE_ENUM.FIZICKA_OSOBA) {
      return Yup.object({
        oib: Yup.string().notRequired(),
        companyName: Yup.string().notRequired(),
      }).notRequired();
    } else if (
      keys &&
      keys[0] &&
      keys[0][0] &&
      (SUBJECT_TYPE_ENUM.OBRT === keys[0][0]?.id ||
        SUBJECT_TYPE_ENUM.SLOBODNA_DJELATNOST === keys[0][0]?.id ||
        SUBJECT_TYPE_ENUM.OPG === keys[0][0]?.id)
    ) {
      return Yup.object({
        oib: Yup.string().notRequired(),
        mb: Yup.string()
          .notRequired()
          .matches(/^\d+$/, messages.ONLY_DIGITS)
          .max(11, messages.MB_MAX_LENGTH),
        companyName: Yup.string().required(messages.MANDATORY_FIELD),
      }).notRequired();
    }
  }),
  applicantAddress: defaultAddressValidation,
  email: Yup.string().email('Neispravan format').notRequired(),
  applicants: Yup.object().when('partyType', (partyType, schema) => {
    if (partyType && partyType[0] && partyType[0][0] && partyType[0][0].id === APPLICANT_PARTY_TYPE_ENUM.OPUNOMOCENIK_PODNOSITELJA) {
      return Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD);
    }
    return Yup.array().notRequired();
  }),
  procurationType: Yup.object().when('partyType', (partyType, schema) => {
    if (partyType && partyType[0] && partyType[0][0] && partyType[0][0].id === APPLICANT_PARTY_TYPE_ENUM.OPUNOMOCENIK_PODNOSITELJA) {
      return Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD);
    }
    return Yup.array().notRequired();
  }),
});
